import React from 'react';
import Layout from '../components/layout';

interface Props {

}

const About = ({ }: Props) => {
  return (
    <Layout>
      <div className="about">
        About
      </div>
    </Layout>
  );
}

export default About;
